"use client";
import { useState, useEffect } from "react";

const Loader = ({ onComplete }: { onComplete: () => void }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isScaling, setIsScaling] = useState(false);

  useEffect(() => {
    const loaderTimer = setTimeout(() => {
      setIsScaling(true);
    }, 2000); 

    const hideTimer = setTimeout(() => {
      setIsVisible(false);
      onComplete(); 
    }, 2500); 

    return () => {
      clearTimeout(loaderTimer);
      clearTimeout(hideTimer);
    };
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-100 z-50">
      <div
        className={`relative w-24 h-24 animate-spin-slow ${
          isScaling ? "animate-scale-up" : ""
        }`}
      >
        {/* Sun Center */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full shadow-lg"></div>
        </div>

        {/* Sun Rays */}
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="absolute inset-0 w-full h-full"
            style={{
              transform: `rotate(${i * 45}deg)`,
            }}
          >
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4 h-6 bg-gradient-to-b from-yellow-400 to-orange-500 clip-triangle"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Loader;